export default __webpack_public_path__ + "static/media/scholar-instructions-3.58f2f16e.svg";